import { Component } from "@angular/core";
import { SvgIcon } from "@ponder-shared/utils/svgIcons";
import { SidebarButtonLinkComponent } from "./sidebar-button-link.component";

@Component({
    selector: "sidebar-advanced-search",
    imports: [],
    templateUrl: "./sidebar-button-link.component.html"
})
export class SidebarAdvancedSearchButtonComponent extends SidebarButtonLinkComponent {
    public constructor() {
        super("Advanced Search", SvgIcon.Search, "search/advanced", false);
    }
}